/**
 * Partner-authored detail HTML (admin TipTap editor) uses <h1>/<h2> for spec
 * lines and section titles — one product page had 29 <h1>s. The page already
 * has its own <h1> (product name) and <h2> ("상품 소개"), so partner h1/h2 are
 * demoted to <h3> under them. `data-h` keeps the original level so
 * DEMOTED_HEADING_CLASSES can restore the exact prose h1/h2 typography — the
 * page looks the same, only the document outline changes.
 */
export function demotePartnerHeadings(html: string): string {
  return html
    .replace(/<h([12])(?=[\s>/])/gi, (_m, level: string) => `<h3 data-h="${level}"`)
    .replace(/<\/h[12]\s*>/gi, "</h3>");
}

/**
 * Tailwind classes for the prose container: demoted headings keep the prose
 * h1/h2 look (@tailwindcss/typography: weight 800/700, strong 900/800;
 * prose-sm size 2.1428571em/1.2 and 1.4285714em/1.4; prose-base (sm:) size
 * 2.25em/1.1111111 and 1.5em/1.3333333). Margins stay with the container's
 * `prose-headings:my-0`.
 */
export const DEMOTED_HEADING_CLASSES =
  "[&_h3[data-h='1']]:font-extrabold [&_h3[data-h='1']]:text-[2.1428571em] [&_h3[data-h='1']]:leading-[1.2] " +
  "sm:[&_h3[data-h='1']]:text-[2.25em] sm:[&_h3[data-h='1']]:leading-[1.1111111] [&_h3[data-h='1']_strong]:font-black " +
  "[&_h3[data-h='2']]:font-bold [&_h3[data-h='2']]:text-[1.4285714em] [&_h3[data-h='2']]:leading-[1.4] " +
  "sm:[&_h3[data-h='2']]:text-[1.5em] sm:[&_h3[data-h='2']]:leading-[1.3333333] [&_h3[data-h='2']_strong]:font-extrabold";
